<template>
  <form-group
      :name="name"
      :label="label"
      :help-text="helpText"
      :error="error"
      :label-width="labelWidth"
      :input-width="inputWidth"
  >
    <vue-tags-input
        v-model="tag"
        :tags="value"
        :autocomplete-items="autocompleteItems"
        @tags-changed="$emit('input', $event)"
    ></vue-tags-input>
  </form-group>
</template>

<script>
import http from '@/http'
import FormGroup from '@/vendor/forms/FormGroups/Block/FormGroup'
import VueTagsInput from '@johmun/vue-tags-input'

export default {
  components: {FormGroup, VueTagsInput},

  props: {
    'name': {},
    'label': {},
    'helpText': {'default': null},
    'value': {},
    'error': {},
    'labelWidth': {},
    'inputWidth': {},
    portal: {}
  },

  data() {
    return {
      tag: '',
      debounce: null,
      autocompleteItems: []
    }
  },

  watch: {
    tag() {
      if (this.tag.length === 0) return

      clearTimeout(this.debounce)

      this.debounce = setTimeout(() => {
        http.get('/api/v2/content-article-tags', {'filter[search]': this.tag, 'filter[portal_id]': this.portal.id})
            .then(response => {
              this.autocompleteItems = response.data.data.map(tag => {
                return {
                  text: tag.attributes.name,
                }
              })
            })
      }, 300)
    }
  }
}
</script>
